'use strict'
import _ from 'lodash'
import store from '../store'

function getToken() {
  return store.getters['mobile/mobileToken'] || ''
}

const service = process.env.VUE_APP_service_licenze || ''

const creaMovimentoRettificaInventario = async function (base, comparazione, aggiorna, istanzaDb) {
  try {
    const data = {
      comparazione,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/inventario/rettifica/${base}${aggiorna ? '?aggiorna=true' : ''}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('creaMovimentoRettificaInventario', err)
  }
}

// Come la rettifica della scheda articolo del backoffice (drawerArticoli.vue):
// il parziale va alla cifra contata, il totale si sposta dello stesso delta
// (non è la somma dei parziali, che possono essere incompleti), i valori seguono
// al prezzo di acquisto. A magazzino singolo il delta parte dal totale.
const applicaRettifica = function (prodotto, magazzino, contata, multipli) {
  if (!prodotto.magazzino) prodotto.magazzino = {}
  const mag = prodotto.magazzino
  const acquisto = mag.prezzoAcquisto || 0
  let partenza = mag.giacenza || 0
  if (multipli && !_.isEmpty(mag.giacenzaParziale)) {
    partenza = _.get(mag, `giacenzaParziale.${magazzino}.giacenza`, 0)
  }
  const delta = +(contata - partenza).toFixed(2)
  _.set(mag, `giacenzaParziale.${magazzino}.giacenza`, contata)
  _.set(mag, `giacenzaParziale.${magazzino}.valore`, +(contata * acquisto).toFixed(2))
  mag.giacenza = +((mag.giacenza || 0) + delta).toFixed(2)
  mag.valore = +((mag.valore || 0) + delta * acquisto).toFixed(2)
  return delta
}

export default {
  creaMovimentoRettificaInventario,
  applicaRettifica
}